import { DirectiveBase } from '../../angular-directive-base.directive';
import { SchemaFormExternalResourceSelectorController } from './schema_form_external_resource_selector.controller';

export class SchemaFormExternalResourceSelector extends DirectiveBase {

  constructor(private $filter) {
    super();
    this.require = ['ngModel'];
    this.bindToController = true;
    this.controller = SchemaFormExternalResourceSelectorController;
    this.controllerAs = 'vm';
    this.restrict = 'A';
    this.scope = false;
    this.link = (scope, iElement, iAttrs, ngModelCtrl) => { this.linkFunction(scope, iElement, iAttrs, ngModelCtrl); };
  }

  private linkFunction(scope, iElement, iAttrs, ngModelCtrl) {
    scope.vm.ngModel = ngModelCtrl;
    scope.filter = this.$filter;
  }
}